<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        icon="mdi-account-multiple"
        :breadcrumbs="breadcrumbs"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mb-5">
        <v-col class="text-right" cols="12">
          <v-btn
              color="primary"
              @click="add"
          >
            Thêm
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="center" class="mt-n6 " justify="center">
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="partner"
              :items-per-page="10"
              class="elevation-1">
            <template v-slot:item.photo_url="{ item }">
              <img :src=" item.photo_url ? url + item.photo_url : require('@/assets/images/logo_Eglife1.png')"
                   width="100">
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon class="mr-2" small @click="editItem(item.id)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item.id)"> mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {DELETE_PARTNER, GET_LIST_PARTNER} from "@/store/modules/partner";

export default {
  name: "Partner",
  data(){
    return{
      page: "Danh sách Partner",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách Partner",
          disabled: false,
        },
      ],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id',
        },
        {text: 'Name', value: 'name'},
        {text: 'Photo', value: 'photo_url', sortable: false},
        {text: 'Position', value: 'order'},
        {text: 'Actions', value: 'actions', sortable: false},
      ],
      url: '',
      selected: -1,

    }
  },
  computed:{
    ...mapGetters({
      partner:"partner",
    })
  },
  async created() {
    this.url = process.env.VUE_APP_API_URL
    await this.$store.dispatch(GET_LIST_PARTNER);
  },
  methods:{
    deleteItem(id) {
      confirm('Bạn có chắc chắn muốn xóa không ?') &&
      this.$store.dispatch(`${DELETE_PARTNER}`, id).then(data => {
        if (data && data.status === 1) {
          this.$store.dispatch(GET_LIST_PARTNER);
        }
      })
    },
    editItem(id) {
      this.$router.push({
        path: "/partner/edit_partner/" + id,
      });
    },
    add(){
      this.$router.push('/partner/add_partner')
    }
  }
}
</script>

<style scoped>

</style>